<template>
    <div class="accordion-item" :class="{'active': visible}">

        <div class="accordion-trigger" @click="open">
            <slot name="accordion-title"></slot>
        </div>

        <transition
                name="accordion"
                @enter="start"
                @after-enter="end"
                @before-leave="start"
                @after-leave="end"
                :duration="300"
        >
            <div class="accordion-content" :class="{ active : visible }" v-show="visible">
                <div class="inner">
                    <slot name="accordion-content"></slot>
                </div>
            </div>
        </transition>
        
    </div>
</template>

<script>
    export default {
        inject: ["Accordion"],
        data() {
            return {
                index: null
            };
        },
        computed: {
            visible() {
                return this.index == this.Accordion.active;
            }
        },
        methods: {
            open() {
                if (this.visible) {
                    this.Accordion.active = null;
                } else {
                    this.Accordion.active = this.index;
                }

                this.$emit('openTriggered');
            },
            start(el) {
                el.style.height = el.scrollHeight + "px";
            },
            end(el) {
                el.style.height = "";
            }
        },
        created() {
            this.index = this.Accordion.count++;
        }
    };
</script>

<style lang="scss" scoped>

    @import "../../../scss/abstracts/variables";

    .accordion-content {
        transition: all 300ms;
    }

    .accordion-enter-active {
        height: 0;
        overflow: hidden !important;
    }
    
    // .accordion-enter-to
    // .accordion-leave-active 

    .accordion-leave-to {
        height: 0 !important;
    }
    
</style>
